/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N8Inputs */

const en_to_yaml_ref_n8 = /** @type {(inputs: To_Yaml_Ref_N8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folded block scalar past 120 characters. Reads back as one line with no trailing newline.`)
};

const ko_to_yaml_ref_n8 = /** @type {(inputs: To_Yaml_Ref_N8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120자를 넘으면 접힌 블록 스칼라가 됩니다. 마지막 줄바꿈 없이 한 줄로 다시 읽힙니다.`)
};

const ja_to_yaml_ref_n8 = /** @type {(inputs: To_Yaml_Ref_N8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`120 文字を超えると畳み込みブロックスカラーになります。末尾の改行なしで 1 行として読み戻されます。`)
};

/**
* | output |
* | --- |
* | "Folded block scalar past 120 characters. Reads back as one line with no trailing newline." |
*
* @param {To_Yaml_Ref_N8Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n8 = /** @type {((inputs?: To_Yaml_Ref_N8Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N8Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n8(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n8(inputs)
	return ja_to_yaml_ref_n8(inputs)
});